import { useEffect } from 'react';

/**
 * Hook to keep Render IMAP sync service awake by pinging the health endpoint
 * This prevents the service from spinning down on Render's free tier
 * 
 * NOTE: Disabled to avoid CORS errors in console. The service will still work
 * but may spin down on Render's free tier after ~15 minutes of inactivity.
 */
export function useKeepRenderAlive() {
  useEffect(() => {
    // Disabled to avoid CORS errors in console
    // If you need to keep the service awake, configure CORS on the IMAP sync service
    // or use a server-side proxy to ping the health endpoint
    
    // Uncomment below to re-enable (requires CORS fix on IMAP sync service):
    /*
    const imapSyncUrl = import.meta.env.VITE_IMAP_SYNC_URL || 'https://imap-sync-427w.onrender.com';
    const PING_INTERVAL = 10 * 60 * 1000; // 10 minutes
    
    const pingService = async () => {
      try {
        fetch(`${imapSyncUrl}/health`, {
          method: 'GET',
          signal: AbortSignal.timeout(5000),
        }).catch(() => {});
      } catch (error) {
        // Ignore errors
      }
    };

    pingService();
    const interval = setInterval(pingService, PING_INTERVAL);
    return () => clearInterval(interval);
    */
  }, []);
}

